import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex gap-x-1 flex-wrap mb-2 w-full justify-center" }
const _hoisted_2 = ["onClick", "onMouseover"]
const _hoisted_3 = { class: "relative w-12 h-12 rounded-full border border-gray-300 flex justify-center items-center overflow-hidden" }
const _hoisted_4 = ["src", "srcset"]
const _hoisted_5 = { class: "text-parameter-text text-[10px] overflow-hidden max-w-14 mx-auto text-center mt-1" }
const _hoisted_6 = { class: "flex gap-x-1 flex-wrap mb-2 w-full justify-center" }
const _hoisted_7 = ["onClick", "onMouseover"]
const _hoisted_8 = { class: "relative w-12 h-12 rounded-full border border-gray-300 flex justify-center items-center overflow-hidden" }
const _hoisted_9 = ["src", "srcset"]
const _hoisted_10 = { class: "text-parameter-text text-[10px] overflow-hidden max-w-14 mx-auto text-center mt-1" }

import ItemV3ParameterBox from "@/components/itemV3/parameter/itemV3ParameterBox.vue";
import ItemV3MostSelected from "@/components/itemV3/parameter/itemV3MostSelected.vue";
import {computed, inject, nextTick, onMounted, onUnmounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {useI18n} from "vue-i18n";
import {ParametersVariations} from "@/assets/ts/parametersVariations";
import {getCurrentText} from "@/assets/ts/itemText";

const imageWidthPercent: number = 30
const boxIdx = "height"

const variantIdx = "height"

const focusValueIdxCount = 5


export default /*@__PURE__*/_defineComponent({
  __name: 'itemV3Height',
  props: ["item"],
  emits: ["patch"],
  setup(__props, { emit: __emit }) {


const {t} = useI18n();

const emit = __emit;
const props = __props;

const store = useStore();

const loadItemVariants = inject<any>("loadItemVariants");

const itemIdx = inject<any>("itemIdx");
const session = inject<any>("session");

const loading = ref(true)

/**
 * Parameter box header images
 */

const mainMetal = computed(() => store.getters["session/getMainMetal"])
const getHeaderImage = (size: string = "600x300", withBg = false) => {
  if (withBg) {
    return `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/menu/${size}/${mainMetal.value}_${boxIdx}.webp`
  } else {
    return `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/menu/${size}/${boxIdx}.webp`
  }
}

/**
 * session
 */

const configureAll = computed(() => store.getters["session/getConfigureAll"])
const parametersVariations = new ParametersVariations(variantIdx, configureAll, session, itemIdx, loadItemVariants)

const open = ref(false)

const variants = computed(() => open.value ? parametersVariations.getVariants() : [])

/**
 * color variants
 */

const activeIdx = ref(0)

const variantsList = computed(() => {
  if (!variants.value.length || variants.value.length < activeIdx.value) return []
  return variants.value[activeIdx.value].values
})

const active = computed(() => {
  if (!variants.value.length || variants.value.length < activeIdx.value) return []
  return variants.value[activeIdx.value]
})

const matchedIdx = computed(() => {
  if (!variants.value.length || variants.value.length < activeIdx.value) return 0
  return variants.value[activeIdx.value].values.findIndex((v: any) => v.match)
})

const currentHeightText = computed(() => {
  return getCurrentText(configureAll.value ? -1 : itemIdx.value, variantIdx)
})

/**
 * image
 */

const hoverIdx = ref(-1)

const setHoverIdx = () => {
  if (matchedIdx.value !== -1 && variantsList.value.length >= matchedIdx.value) {
    hoverIdx.value = matchedIdx.value
  }
}

watch(active, () => {
  setHoverIdx()
})

watch(props.item, () => {
  setHoverIdx()
})

/**
 * slider
 */

const sliderRef = ref<HTMLElement | null>(null)
const canScrollLeft = ref(false)
const canScrollRight = ref(false)

const updateScrollState = () => {
  const el = sliderRef.value
  if (!el) {
    canScrollLeft.value = false
    canScrollRight.value = false
    return
  }
  canScrollLeft.value = el.scrollLeft > 0
  canScrollRight.value = Math.ceil(el.scrollLeft + el.clientWidth) < el.scrollWidth
}

const scrollMatchedIntoView = () => {
  if (matchedIdx.value === -1) return
  const el = sliderRef.value?.querySelector(`[data-variant-idx="${matchedIdx.value}"]`) as HTMLElement | null
  el?.scrollIntoView({behavior: 'smooth', inline: 'center', block: 'nearest'})
}

watch(matchedIdx, () => {
  scrollMatchedIntoView()
})

watch(variantsList, () => {
  scrollMatchedIntoView()
  nextTick(() => updateScrollState())
})

const imageUrl = computed(() => parametersVariations.imageUrl(variantsList.value, hoverIdx.value))

const getMainImageUrl = (image: string) => {
  if (!image) return ''
  return image
}

const getHeightImageUrl = (height: string | number, size: 300 | 600 = 600) => {
  const key = Number(height).toFixed(1).replace('.', '_')
  return `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/height/${size}x${size}/ringhoehe_${key}mm.webp`
}

const checkImageLoaded = (url: string) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(true);
    img.src = url;
  });
};

const checkAllLoaded = async () => {
  const profiles = variants.value;

  if (!profiles.length) return;
  const allListsCreated = profiles.every((profile: any) => profile.values && profile.values.length > 0);
  if (!allListsCreated) return;

  const imageUrls = profiles.flatMap((disc: any) => disc.values.map((profile: any) => getMainImageUrl(profile.image.filename)));
  await Promise.all(imageUrls.map((url: string) => checkImageLoaded(url)));

  loading.value = false;
};

watch(variants, () => {
  checkAllLoaded();
  if (variants.value.length > 0) {
    loading.value = true;
  }
}, {immediate: true, deep: true});

/**
 * Patch
 */

const handleValuePatch = (actionIdx: string, value: any) => {
  emit('patch', {
    action: actionIdx,
    value: value.idx,
    certificated_diamond: value.certificated_diamond
  });
};

/**
 * slider navigation
 */

const scrollSliderBy = (direction: 1 | -1) => {
  const el = sliderRef.value
  if (!el) return
  const item = el.querySelector('[data-variant-idx]') as HTMLElement | null
  const amount = item ? item.offsetWidth + 8 : el.clientWidth * 0.8
  el.scrollBy({left: direction * amount, behavior: 'smooth'})
}

const goToPrev = () => {
  scrollSliderBy(-1)
}

const goToNext = () => {
  scrollSliderBy(1)
}

/**
 * tip texts
 */

const getTipTitle = computed(() => {
  if (active.value && active.value.values[hoverIdx.value]) {
    const key = Number(active.value.values[hoverIdx.value].idx).toFixed(1).replace('.', '')
    return t('components.parameters.tips.height.' + key + '.title')
  } else {
    return ''
  }
})

const getTipText = computed(() => {
  if (active.value && active.value.values[hoverIdx.value]) {
    const key = Number(active.value.values[hoverIdx.value].idx).toFixed(1).replace('.', '')
    return t('components.parameters.tips.height.' + key + '.text')
  } else {
    return ''
  }
})

const getTipImageUrl = computed(() => {
  if (active.value && active.value.values[hoverIdx.value]) {
    const key = Number(active.value.values[hoverIdx.value].idx).toFixed(1)

    return "https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/tips/height/600x600/height_" + key + ".webp"
  } else {
    return ''
  }
})

onMounted(
    () => {
      setHoverIdx()
      nextTick(() => {
        scrollMatchedIntoView()
        updateScrollState()
      })
      sliderRef.value?.addEventListener('scroll', updateScrollState)
      window.addEventListener('resize', updateScrollState)
    }
)

onUnmounted(() => {
  sliderRef.value?.removeEventListener('scroll', updateScrollState)
  window.removeEventListener('resize', updateScrollState)
})

/*
 * focus values
 */

const focusValueIdx = [
  // idx must be a string with one decimal digit
  "1.4", "1.6", "1.8", "2.0", "2.2"
]

const formatNumber = (num: number) => {
  return Number(num).toFixed(1)
}

const getFocusValueIdx = computed(
    () => {
      let focusList = focusValueIdx

      if (matchedIdx.value && matchedIdx.value != -1) {
        if (!focusValueIdx.includes(formatNumber(variants.value[activeIdx.value].values[matchedIdx.value].idx))) {
          focusList = [
            formatNumber(variants.value[activeIdx.value].values[matchedIdx.value].idx),
            ...focusValueIdx.slice(0, -1)
          ]
        }
      }

      const availableFocus = variantsList.value
          .map((v: any) => formatNumber(v.idx))
          .filter((idx: string) => focusList.includes(idx))

      if (availableFocus.length < focusValueIdxCount) {
        const nextNonFocus = variantsList.value
            .map((v: any) => formatNumber(v.idx))
            .filter((idx: string) => !availableFocus.includes(idx))

        availableFocus.push(...nextNonFocus.slice(0, focusValueIdxCount - availableFocus.length))
      }

      return availableFocus
    }
)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ItemV3ParameterBox, {
    open: open.value,
    "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((open).value = $event)),
    "image-width-percent": imageWidthPercent,
    image: imageUrl.value,
    "header-image": getHeaderImage(),
    "header-image-srcset": getHeaderImage() + ' 300w, ' + getHeaderImage('1200x600') +' 600w',
    title: "Höhe",
    subtitle: currentHeightText.value || 'Wählen Sie die Höhe für Ihre Trauringe',
    loading: loading.value,
    "tip-title": getTipTitle.value,
    "tip-text": getTipText.value,
    "tip-image": getTipImageUrl.value
  }, {
    main: _withCtx(() => [
      _createVNode(ItemV3MostSelected),
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variantsList.value, (variantData, variantIdx) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (getFocusValueIdx.value.includes(formatNumber(variantData.idx)))
              ? (_openBlock(), _createElementBlock("li", {
                  key: variantIdx,
                  class: _normalizeClass(["cursor-pointer flex flex-col items-center py-2 px-1 rounded-2xl hover:bg-[#f3f0e9]", {
              'border-2 border-brand-main bg-[#f3f0e9]': variantData.match,
              'border-2 border-transparent': !variantData.match
            }]),
                  onClick: ($event: any) => (handleValuePatch(active.value.idx, variantData)),
                  onMouseover: ($event: any) => (hoverIdx.value = variantIdx as number),
                  onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (hoverIdx.value = matchedIdx.value))
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("img", {
                      src: getHeightImageUrl(variantData.idx, 300),
                      srcset: getHeightImageUrl(variantData.idx, 600),
                      loading: "lazy",
                      class: "relative w-auto h-20 top-2 object-cover",
                      alt: ""
                    }, null, 8, _hoisted_4)
                  ]),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(variantData.title), 1)
                ], 42, _hoisted_2))
              : _createCommentVNode("", true)
          ], 64))
        }), 256))
      ])
    ]),
    more: _withCtx(() => [
      _createElementVNode("ul", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variantsList.value, (variantData, variantIdx) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (!getFocusValueIdx.value.includes(formatNumber(variantData.idx)))
              ? (_openBlock(), _createElementBlock("li", {
                  key: variantIdx,
                  class: _normalizeClass(["cursor-pointer flex flex-col items-center py-2 px-1 rounded-2xl hover:bg-[#f3f0e9]", {
              'border-2 border-brand-main bg-[#f3f0e9]': variantData.match,
              'border-2 border-transparent': !variantData.match
            }]),
                  onClick: ($event: any) => (handleValuePatch(active.value.idx, variantData)),
                  onMouseover: ($event: any) => (hoverIdx.value = variantIdx as number),
                  onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (hoverIdx.value = matchedIdx.value))
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: getHeightImageUrl(variantData.idx, 300),
                      srcset: getHeightImageUrl(variantData.idx, 600),
                      loading: "lazy",
                      class: "relative w-auto h-20 top-2 object-cover",
                      alt: ""
                    }, null, 8, _hoisted_9)
                  ]),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(variantData.title), 1)
                ], 42, _hoisted_7))
              : _createCommentVNode("", true)
          ], 64))
        }), 256))
      ])
    ]),
    _: 1
  }, 8, ["open", "image", "header-image", "header-image-srcset", "subtitle", "loading", "tip-title", "tip-text", "tip-image"]))
}
}

})